export default {
  // 导航栏
  nav: {
    brandName: "ORedact",
    products: 'Products',
    examples: "Examples",
    pricing: "API pricing",
    about: 'About Us',
    login: "Console login",
    damaya: "Damaya",
    register: "Apply for API trial"
  },
  
  // 产品模块
  products: {
    textRedaction: 'Text Privacy Processing',
    textRedactionDesc: "Assessed with samples",
    fileRedaction: 'File Privacy Processing', 
    fileRedactionDesc: "PDF / JSON / CSV, assessed with samples",
    imageRedaction: 'Image Privacy Processing',
    imageRedactionDesc: "Faces, plates, sensitive text",
    videoRedaction: 'Video Privacy Processing',
    videoRedactionDesc: "Faces and plates, tracked frame by frame"
  },
  
  // 通用
  common: {
    learnMore: 'Learn More',
    getStarted: 'Get Started',
    tryNow: "Use Damaya",
    contactUs: 'Contact Us',
    viewMore: 'View More',
    before: "Before",
    after: "After",
    sourceNote: "Output clips come from the Damaya production pipeline; the footage is phone video we shot ourselves. Some stills carry the preview watermark.",
    aiNote: "The crowd, street and traffic source images are AI-generated and show no real person; the results are real production output.",
    startTrial: 'Start Trial'
  },
  
  // 主页
  home: {
    heroTitle: "Privacy redaction for images and video",
    heroSubtitle: "Do it yourself with Damaya; integrate with the ORedact API",
    heroDesc: "Faces, license plates and sensitive text are detected and redacted automatically. The enterprise API is available by invitation: validate on your footage first, then agree on integration and pricing.",
    heroImageAlt: "AI-generated street scene; plates and faces redacted by the system are marked in green",
    heroImageCaption: "AI-generated scene, no real person; green marks show the faces and plates Damaya redacted",
    featuresTitle: "What it does",
    featuresSubtitle: "Image and video redaction are available now; text and document redaction start with a sample assessment.",
    featuresDesc: "Learn how images and video are processed; text and document requests start with a sample assessment.",
    demoFaceTitle: "Faces in a crowd",
    demoFaceDesc: "An AI-generated crowd image processed by the pipeline: every face softly blurred, clothing and background unchanged. Drag the slider to compare.",
    demoTextTitle: "Text in images",
    demoTextDesc: "The phone number on a shop sign is masked; the shop name and other text stay.",
    demoKeepTitle: "Keep selected people",
    demoKeepDesc: "The automatic result blurs everyone; marking our own child as kept and re-rendering leaves everyone else blurred.",
    keepBefore: "Automatic",
    keepAfter: "Kept",
    demoNote: "Text and document redaction are assessed with samples and are not shown here.",
    viewDemo: "Explore the enterprise API",
    pathTitle: "Which one fits you",
    pathDesc: "Individuals and small teams upload and process directly; teams integrating into their own systems apply for an API trial.",
    pathDamayaBadge: "Self-service web app",
    pathDamayaTitle: "Damaya",
    pathDamayaMore: "About Damaya",
    pathDamayaDesc: "Upload an image or video; the system detects faces, plates and sensitive text, you confirm in the editor and export.",
    pathDamayaPoint1: "Free trial allowance, monthly passes",
    pathDamayaPoint2: "Keep selected people, add manual redactions; five styles: mosaic, blur, solid, eye bar, sticker",
    pathDamayaPoint3: "Review and download in the browser, nothing to install",
    pathApiBadge: "Integration · by invitation",
    pathApiTitle: "ORedact API",
    pathApiDesc: "Bring redaction into your workflow: submit a task, poll its status, receive a callback. Validate on your footage first, then fix scope and pricing.",
    pathApiPoint1: "Per image and per second of video; only successful processing is charged",
    pathApiPoint2: "14-day trial: 100 images + 10 minutes of video",
    pathApiPoint3: "Retention, concurrency and support confirmed in writing before go-live",
    capsTitle: "Scope",
    capsPrimaryLabel: "Available now:",
    capsPrimary: "faces, license plates and sensitive text in video and images.",
    capsAssessLabel: "Assessed first:",
    capsAssess: "text and document redaction.",
    factsTitle: "Capabilities and rules",
    factsDesc: "What Damaya and the enterprise API actually provide, plus the billing and data rules that apply on integration.",
    fact1: "Targets: faces, license plates and sensitive text in images (phone numbers, addresses, ID numbers).",
    fact2: "Every frame of a video is processed; moving faces and plates are covered continuously along their tracks, not only on key frames.",
    fact3: "Review every object in the editor afterwards: keep selected people, add regions and re-render without uploading again.",
    fact4: "Output matches the source specification with the audio track kept; 4K and HEVC sources are supported.",
    fact5: "The API charges only for successful processing; system failures are free and automatic retries are not double-billed.",
    fact6: "Retention and deletion of source files, caches and results are agreed in writing before go-live.",
    apiTitle: "Three steps to integrate",
    apiDesc: "Submit a task, check its status, fetch the result, or configure a callback. Interface documentation is provided during the trial.",
    apiStep1Title: "Submit a task",
    apiStep1Desc: "Give the file location and targets (faces, plates, sensitive text); optionally the masking style and a callback URL.",
    apiStep2Title: "Check status",
    apiStep2Desc: "Poll progress or wait for the callback; queueing and status checks are free.",
    apiStep3Title: "Fetch the result",
    apiStep3Desc: "Download the output and object list and keep them within the agreed retention period.",
    apiNote: "Illustrative flow; endpoints and fields follow the integration documentation.",
    textRedactionDesc: "Explore text redaction methods and assess entity coverage, outputs and integration with samples.",
    fileRedactionDesc: "Assess sensitive information in PDF, JSON, CSV and TXT files. Office documents are outside the current standard API scope.",
    imageRedactionDesc: "Detect faces, license plates and sensitive text, with blur, pixelation or masking. Review results before use.",
    scenariosTitle: "Common scenarios",
    scenariosDesc: "Four kinds of footage, by where it comes from.",
    scenario1Title: "Inspections and field records",
    scenario1Desc: "Phone photos and videos from site visits: remove bystanders' faces and plates before sharing.",
    scenario2Title: "Vehicle and road footage",
    scenario2Desc: "Plates and faces in insurance, repair and road records, processed in bulk inside your existing system.",
    scenario3Title: "Publishing and collaboration",
    scenario3Desc: "Passers-by in shop visits, street footage and event videos before publishing.",
    scenario4Title: "Business system integration",
    scenario4Desc: "Asynchronous submission, status polling and result callbacks; integrate first, then go live.",
    demoTitle: "Results",
    demoDesc: "Real output frames; validate on your own samples.",
    ctaTitle: "Bring redaction into your workflow",
    ctaDesc: "The enterprise API is available by invitation. Tell us your footage type, volume and turnaround needs; validate first, then agree on a plan.",
    freeTrialBtn: "Apply for an API trial",
    contactBtn: "View API pricing",
    viewMoreExamples: "More examples"
  },
  
  // 价格页面
  pricing: {
    "status": "Enterprise API · By invitation",
    "heroTitle": "Pay per image and video minute",
    "heroSubtitle": "Bring image and video redaction into your system. Validate on real footage first, then fix scope, volume and pricing.",
    "statusNote": "Reference pricing. Access is opened after sample validation and commercial confirmation; it is not available for direct online purchase yet.",
    "plansLabel": "API options",
    "trialBadge": "Validate your results first",
    "trialTitle": "Integration trial",
    "trialPrice": "Free",
    "trialDesc": "{{trialDays}}-day test period covering the full flow from submitting a task to fetching the result.",
    "trialQuota": "{{trialImages}} images + {{trialVideoMinutes}} standard video minutes",
    "trialEligibility": "One trial per organization, subject to approval",
    "trialScope": "Agree on media specifications, targets and acceptance criteria",
    "applyTrial": "Apply for an API trial",
    "standardBadge": "Reference pricing",
    "standardTitle": "Usage-based API",
    "imageLabel": "Standard images",
    "videoLabel": "Standard video",
    "perImage": "/ image",
    "perMinute": "/ minute",
    "startingBalance": "Prepay from CNY {{startingBalance}}; no monthly platform fee",
    "standardBilling": "Images by count; video by the second, not file size",
    "standardDelivery": "One output without a brand watermark and normal downloads included",
    "standardFailure": "No processing charge for system failures or automatic retries",
    "applyStandard": "Discuss access",
    "customBadge": "Scope assessment",
    "customTitle": "Volume and deployment needs",
    "customPrice": "Discuss your requirements",
    "customDesc": "Share your samples and expected usage for recurring batches, a fixed monthly budget or deployment requirements.",
    "customVolume": "Monthly commitments, peak submissions and acceptable waiting times",
    "customCapacity": "Dedicated capacity, private deployment and custom integration assessed separately",
    "customBoundary": "No off-the-shelf enterprise plan, unlimited usage or standard SLA yet",
    "contact": "Discuss requirements",
    "damayaTitle": "Just want to upload a file and go?",
    "damayaDesc": "Damaya serves individuals and small teams. Plans and trial rules follow the Damaya site.",
    "damayaAction": "Open Damaya",
    "scopeTitle": "Agree on specifications before pricing",
    "imageScopeTitle": "Standard image scope",
    "imageScope": "Currently supported: JPEG, PNG and WebP, up to {{maxImageMegapixels}}MP. Validate results for your required faces, license plates or sensitive text.",
    "videoScopeTitle": "Standard video scope",
    "videoScope": "Currently supported: up to {{maxVideoHeight}}p, {{maxVideoFps}} FPS and {{maxVideoMinutes}} minutes per clip. Assess 4K, higher frame rates, complex text and dense crowds separately.",
    "billingScopeTitle": "Charge on successful processing",
    "billingScope": "Input video duration is rounded up to the next second and charged at the per-minute rate. Queueing, status queries and callbacks add no processing fees. Validation errors and system processing failures are not charged.",
    "deliveryScopeTitle": "Delivery and support boundaries",
    "deliveryScope": "Includes one output without a brand watermark, normal downloads and standard API support. Customers review and save their results. Long-term hosting, distribution, custom development and reserved capacity require a separate agreement.",
    "exampleTitle": "Budget example: 300 people, one 30-second clip per day",
    "exampleDesc": "Over 30 days, that is 9,000 clips or {{exampleMinutes}} standard video minutes. At CNY {{videoPrice}}/minute, estimated processing fees are CNY {{exampleCost}}/month.",
    "exampleNote": "This is a shared-capacity usage example within standard specifications, not a dedicated server plan or a turnaround guarantee. Charges follow successful usage; fixed monthly budgets can be discussed separately.",
    "processTitle": "From sample validation to production access",
    "sampleTitle": "Share requirements and samples",
    "sample": "Describe your targets, media specifications, monthly volume, peaks and turnaround needs. Use representative samples you are authorized to process.",
    "integrationTitle": "Complete the integration trial",
    "integration": "After approval, receive a test Key and integration materials. Validate asynchronous tasks, status queries, callbacks and failure recovery.",
    "productionTitle": "Agree on terms and activate",
    "production": "Confirm pricing, balance validity, retention, concurrency and support before production access and usage reconciliation.",
    "faqTitle": "Billing and integration questions",
    "faq": {
      "prepay": {
        "question": "Is CNY 200 a monthly fee? Does the balance reset monthly?",
        "answer": "It is a prepaid balance for successful processing after activation, not a monthly fee. There is no additional monthly platform fee or monthly reset. The proposed balance validity is 12 months; expiry, reminders and handling of unused funds will be confirmed in writing before activation."
      },
      "failure": {
        "question": "How are failures, retries and reprocessing charged?",
        "answer": "System failures release reserved funds. Automatic retries, the same idempotent request and duplicate callbacks are not charged twice. Changing parameters and starting a new processing task incurs a new charge, confirmed before execution. Normal result downloads do not incur another processing fee."
      },
      "formats": {
        "question": "Does the same rate cover 4K, long videos and documents?",
        "answer": "These rates apply to validated standard images and video. 4K, higher frame rates, long videos, complex scenes, text and documents require sample assessment. Unconfirmed specifications are not automatically included."
      },
      "retention": {
        "question": "How long are files kept? Is long-term storage included?",
        "answer": "Source, cache and result retention and deletion procedures are agreed before activation. Customers must save results within the agreed period. Long-term file hosting is not included; immediate deletion after processing is not a universal promise."
      },
      "support": {
        "question": "Are private deployment, dedicated servers or 24/7 support included?",
        "answer": "The standard API uses shared capacity and weekday support for documentation, examples and error diagnosis. Dedicated capacity, private deployment, customer system development and SLAs require separate assessment and are not off-the-shelf products."
      },
      "damaya": {
        "question": "Can I share my Damaya plan with the API?",
        "answer": "Damaya serves self-service web users; the enterprise API serves system integrations. Plans, trial allowances and billing entitlements are separate. Refer to Damaya for its current terms."
      }
    },
    "contactTitle": "Tell us what you need first",
    "contactDesc": "Include your company and contact details, footage type, monthly volume, peak submissions and target turnaround. How to transfer samples is agreed afterwards.",
    "sendApplication": "Apply for an API trial by email",
    "emailAlternative": "Or copy our email address:",
    "aboutLink": "Company and contact details"
  },
  
  // 产品页面通用
  productCommon: {
    howItWorks: 'How It Works',
    keyFeatures: 'Key Features',
    benefits: 'Benefits',
    getStarted: 'Get Started',
    uploadFile: 'Upload File',
    processing: 'AI Processing',
    downloadResult: 'Download Result'
  },
  
  // Footer
  footer: {
    productsTitle: 'Products',
    textRedaction: 'Text Redaction',
    fileRedaction: 'File Redaction',
    imageRedaction: 'Image Redaction',
    videoRedaction: 'Video Redaction',
    supportTitle: 'Support',
    examples: 'Examples',
    pricing: "API pricing",
    apiDocs: "API integration process",
    helpCenter: "Billing and integration FAQ",
    techSupport: 'Technical Support',
    legalTitle: 'Legal',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    security: "Retention and deletion",
    compliance: "Service scope",
    contactTitle: 'Contact Us',
    about: 'About Us',
    copyright: "© 2026 Zhengzhou ORedact Information Technology Co., Ltd.",
    poweredBy: 'Powered by Readdy',
    products: 'Products',
    support: 'Support',
    documentation: 'Documentation',
    apiReference: 'API Reference',
    legal: 'Legal',
    contact: 'Contact',
    email: 'Email',
    address: 'Address',
    addressValue: 'Building 3, No. 56 Beihuan Road, Jinshui District, Zhengzhou',
  },

  // Examples Page
  examplesNew: {
    heroTitle: "Results",
    heroSubtitle: "Source and result side by side. Image examples are real production output; validate on your own footage.",
    textTitle: "Text redaction",
    textSubtitle: "Names, ID numbers, phone numbers, addresses and emails are detected and masked by field.",
    before: 'Before',
    after: 'After',
    idNumber: "ID Number",
    phone: 'Phone',
    homeAddress: "Shipping Address",
    emailAddress: 'Email Address',
    demoCustomerName: "Zhang Minghua", demoHomeAddress: "88 Jianguo Road, Chaoyang District, Beijing",
    customerName: "Customer Name",
    ticketNote: "Ticket Note",
    ticketContent: "Customer reports the 12 October order was not received; a replacement has been arranged, please confirm within 3 days.",
    fileCard1Title: "Assessed first",
    fileCard1Desc: "PDF, JSON, CSV and TXT: confirm targets, output format and readability on real samples before integration.",
    fileCard2Title: "Separate confirmation",
    fileCard2Desc: "Word, Excel, PowerPoint and other Office files are outside the standard API scope and assessed per request.",
    fileLink: "Document processing details",
    textSign: "Sign text",
    crowdTitle: "Faces in a crowd",
    crowdDesc: "All eight faces, near and far, detected and softly blurred; clothing, scarves and background unchanged.",
    streetTitle: "Street: faces and plates",
    streetDesc: "Pedestrian faces and parked-car plates masked together; signs and shopfronts kept.",
    trafficTitle: "Traffic plates",
    trafficDesc: "Plates on several vehicles detected and blurred one by one; lights, badges and road unchanged.",
    signDesc: "The phone number on the sign is masked; the rest of the text stays.",
    keepObject: "Keep selected people",
    keepDesc: "The automatic result blurs everyone; our own child is marked as kept and the video re-rendered.",
    keepBefore: "Automatic",
    keepAfter: "Kept",
    mallTitle: "Mall entrance, 20-second phone video",
    mallDesc: "Every face of passers-by and family detected and blurred automatically; audio kept, so you can unmute.",
    editorTitle: "Review in the editor after processing",
    editorDesc: "Confirm or keep each object in the grid, fix misses and re-render without uploading again.",
    fileTitle: "Document redaction",
    fileSubtitle: "Assessed with samples; no synthetic mock-ups here.",
    imageTitle: "Image redaction",
    imageSubtitle: "Unredacted source on the left, result on the right. Drag the slider to compare.",
    videoTitle: "Video redaction",
    videoSubtitle: "Output clips play directly; object review and keeping happen in the editor.",
    statsTitle: 'Processing Capabilities',
    statsSubtitle: 'ORedact\'s powerful processing capabilities',
    accuracy: 'Recognition Accuracy',
    accuracyDesc: 'High-precision recognition based on deep learning',
    speed: 'Processing Speed',
    speedDesc: 'Single image processing time',
    formats: 'Supported Formats',
    formatsDesc: 'Document, image, video formats',
    availability: 'Service Availability',
    availabilityDesc: '24/7 stable service',
    ctaTitle: "Validate on your own footage",
    ctaSubtitle: "Apply for an API trial: 100 images and 10 minutes of video within 14 days.",
    freeTrial: "Apply for an API trial",
    contactSales: "Contact us",
  },

  // About Page
  aboutNew: {
    heroTitle: 'About Us',
    heroSubtitle: "Zhengzhou ORedact Information Technology does one thing: privacy redaction for images and video, with an in-house pipeline and models, the Damaya web app, and an enterprise API available by invitation.",
    companyTitle: 'Company Profile',
    companyP1: "We do one thing: detect and mask faces, license plates and sensitive text in images and video. Damaya is the self-service web app for individuals and small teams; the ORedact API is for development teams integrating into their own systems.",
    companyP2: "Based in Zhengzhou, incorporated in September 2025 after the project started in July 2025. The pipeline, editor and detection models are built in-house; the models are trained continuously on our own footage and improved against real scenes.",
    companyP3: "The enterprise API is available by invitation: validate footage and workflow first, then agree on price, capacity and support. Dedicated capacity and on-premises deployment are assessed separately; there is no standard enterprise plan yet.",
    infoTitle: "Company",
    infoCompany: "Legal name",
    infoFounded: "Founded",
    infoFoundedValue: "September 2025",
    infoIcp: "ICP filing",
    infoPsb: "Public security filing",
    matrixTitle: "Products",
    matrixDamayaTitle: "Damaya · self-service web app",
    matrixDamayaDesc: "Online redaction for individual creators and small teams: upload an image or video, detect faces, plates and sensitive text, review and export.",
    matrixApiTitle: "ORedact API · integration",
    matrixApiDesc: "For development teams integrating redaction into their systems. Currently by invitation: validate footage first, then fix scope, volume and pricing.",
    matrixApiCta: "API pricing and how to apply",
    boundaryTitle: "Scope of service",
    boundary1: "Image and video redaction are available now; text and document redaction are assessed with samples.",
    boundary2: "No standard enterprise plan yet; no unlimited usage or off-the-shelf SLA. Dedicated capacity and on-premises deployment are assessed separately.",
    boundary3: "Uploaded content is used only to complete that processing request and is never used to train models.",
    companyImageCaption: "Damaya editor: review each object, keep or add redactions, re-render.",
    heroChip1: "Founded September 2025 · Zhengzhou",
    heroChip2: "Damaya live since April 2026",
    heroChip3: "Models trained on our own footage",
    approachTitle: "How we work",
    approachDesc: "Redaction quality comes down to four things: detection rate, tracking stability, output quality and review effort. We focus on those four.",
    approach1Title: "One in-house pipeline",
    approach1Desc: "Detection, tracking, rendering and encoding run in a single GPU pipeline. Output matches the source video's specification and keeps the audio track; 4K and HEVC sources are supported.",
    approach2Title: "Models trained on our own footage",
    approach2Desc: "The plate model is trained on dashcam footage we collect ourselves; the face model is iterated on crowds, profiles and small distant faces. Both switched to in-house versions in October 2026. Uploaded content is never used for training.",
    approach3Title: "One person, one identity",
    approach3Desc: "Multiple appearances of the same person in a video are grouped, so keeping someone visible takes one click. Detections can be reviewed frame by frame, and a re-render after adding regions needs no re-upload.",
    approach4Title: "Improved against real scenes",
    approach4Desc: "Every change is compared frame by frame on our own test sets, with misses, false positives and processing time recorded before it goes live.",
    dataTitle: "Data and security",
    dataDesc: "These commitments are written into the privacy policy and terms of service.",
    data1: "Images, videos and results uploaded to Damaya are deleted automatically within 24 hours of completion; for API customers, retention and deletion are agreed in writing before access.",
    data2: "Uploaded content is used only to complete that request and is never used to train models.",
    data3: "Services run in mainland China, files are stored in Alibaba Cloud Object Storage, and all transfers use HTTPS.",
    data4: "The website and service hold ICP and public security filings; the privacy policy states what is collected, how long it is kept and users' rights.",
    timelineTitle: "Milestones",
    tl1Date: "July 2025", tl1Text: "Project started: redaction backend and website development begins.",
    tl2Date: "September 2025", tl2Text: "Zhengzhou ORedact Information Technology Co., Ltd. incorporated.",
    tl3Date: "October 2025", tl3Text: "Video engine started: GPU pipeline, face and plate detection, tracking and rendering.",
    tl4Date: "March 2026", tl4Text: "Development of the Damaya web app begins.",
    tl5Date: "April 2026", tl5Text: "Damaya launches with paid watermark-free downloads.",
    tl6Date: "October 2026", tl6Text: "In-house plate and face models go live; processing history and re-editing; enterprise API pricing published.",
    resourcesTitle: "Resources",
    resourceHelp: "Damaya help centre (15 guides)",
    resourcePrivacy: "Privacy policy",
    resourcePricing: "Enterprise API pricing",
    contactTitle: 'Contact Us',
    contactSubtitle: "API access, volume partnerships and deployment requests: email us.",
    emailTitle: 'Email Address',
    addressTitle: 'Company Address',
    addressValue: 'Building 3, No. 56 Beihuan Road, Jinshui District, Zhengzhou',
    workingHours: 'Working Hours',
    workingDays: 'Monday to Friday',
    workingTime: '9:00 - 18:00',
  },
  
  // Text Redaction Page
  'textRedaction.heroTitle': 'Text Privacy Processing',
  'textRedaction.heroSubtitle': "Detects names, phone numbers, addresses and ID numbers in mixed Chinese and English text; the exact scope is confirmed on samples.",
  'textRedaction.feature1Title': "Mixed languages",
  'textRedaction.feature1Desc': "Chinese, English and digits in the same passage are recognised together.",
  'textRedaction.feature2Title': "Entity types",
  'textRedaction.feature2Desc': "Names, addresses, mobile numbers, ID numbers, emails.",
  'textRedaction.feature3Title': "Batch and structured",
  'textRedaction.feature3Desc': "Process text in batches with results returned by field.",
  'textRedaction.tryTitle': "Try it",
  'textRedaction.trySubtitle': "This demo runs simple rules in your browser to highlight and mask; it does not represent the production API.",
  'textRedaction.highlightMode': "Highlight",
  'textRedaction.redactMode': "Mask",
  'textRedaction.inputLabel': 'Input Text',
  'textRedaction.characters': 'characters',
  'textRedaction.inputPlaceholder': 'Please enter text containing privacy information, for example: I am John Smith, my phone number is 13812345678, ID number is 110101199001011234...',
  'textRedaction.outputLabel': "Result",
  'textRedaction.outputPlaceholder': "The result appears here",
  'textRedaction.processing': 'Processing...',
  'textRedaction.startButton': 'Start Recognition',
  'textRedaction.exampleTitle': 'Example Text:',
  'textRedaction.exampleText': 'I am Zhang San, currently living at No. 88 Jianguo Road, Chaoyang District, Beijing. My phone number is 13812345678, and my ID number is 110101199001011234. Please contact me at zhangsan@email.com if needed.',
  'textRedaction.useExample': 'Use This Example',
  'textRedaction.techTitle': "How It Works",
  'textRedaction.techSubtitle': "Entity scope and output format are fixed on samples",
  'textRedaction.tech1Title': "Entity Recognition",
  'textRedaction.tech1Desc': "Names, phone numbers, addresses, ID numbers and more; coverage is validated on your samples.",
  'textRedaction.tech2Title': "Custom Rules",
  'textRedaction.tech2Desc': "Word lists and regular expressions for industry-specific identifiers and fields.",
  'textRedaction.tech3Title': "Redaction Methods",
  'textRedaction.tech3Desc': "Masking, replacement or generalisation; the format is fixed before integration.",
  'textRedaction.casesTitle': "Common text",
  'textRedaction.casesSubtitle': "Three text types that come up in scoping; the scope follows the assessment.",
  'textRedaction.case1Title': "Business Records and Tickets",
  'textRedaction.case1Desc': "Contact details and ID numbers in support records, tickets and form exports, masked by field.",
  'textRedaction.case2Title': "Accompanying text",
  'textRedaction.case2Desc': "Personal information in captions, subtitles and annotations that come with images and video.",
  'textRedaction.case3Title': "Survey and Interview Records",
  'textRedaction.case3Desc': "Personal information in questionnaires and interview transcripts.",
  'textRedaction.ctaTitle': "Assess your text redaction needs",
  'textRedaction.ctaSubtitle': "Describe text type, volume and output requirements; scope is confirmed before integration.",
  'textRedaction.ctaButton': "Request an assessment",
  
  // Image Redaction Page
  'imageRedaction.heroTitle': 'Image Privacy Processing',
  'imageRedaction.heroSubtitle': "Faces, license plates and sensitive text detected and masked with blur, mosaic or solid fill. The enterprise API validates samples first; you review the results.",
  'imageRedaction.feature1Title': "Faces",
  'imageRedaction.feature1Desc': "Several people in one frame are detected together, near and far.",
  'imageRedaction.feature2Title': "Plates",
  'imageRedaction.feature2Desc': "Standard blue plates and new-energy green plates.",
  'imageRedaction.feature3Title': "Sensitive text",
  'imageRedaction.feature3Desc': "Phone numbers, addresses and ID numbers printed in images; coverage validated on samples.",
  'imageRedaction.effectTitle': "Three masking styles",
  'imageRedaction.effectSubtitle': "Three outputs of the same frame, all real pipeline results (cropped).",
  'imageRedaction.blurMode': "Blur",
  'imageRedaction.pixelateMode': "Mosaic",
  'imageRedaction.maskMode': "Solid",
  'imageRedaction.originalTitle': "Source",
  'imageRedaction.originalDesc': "Same frame",
  'imageRedaction.processedTitle': "Result",
  'imageRedaction.blurDesc': "Blur: soft edges, natural look",
  'imageRedaction.pixelateDesc': "Mosaic: pixel-block masking",
  'imageRedaction.maskDesc': "Solid: full coverage",
  'imageRedaction.examplesTitle': "Examples",
  'imageRedaction.examplesSubtitle': "Unredacted source on the left, real output on the right",
  'imageRedaction.example1Title': "Faces in a crowd",
  'imageRedaction.example1Desc': "Near and distant faces all detected and blurred; clothing and background unchanged.",
  'imageRedaction.example2Title': "Street: faces and plates",
  'imageRedaction.example2Desc': "Pedestrian faces and parked-car plates masked together; signs and shopfronts kept.",
  'imageRedaction.example3Title': "Traffic plates",
  'imageRedaction.example3Desc': "Plates on several vehicles blurred one by one; lights and badges unchanged.",
  'imageRedaction.techTitle': "What affects results",
  'imageRedaction.techSubtitle': "Four things to know before integrating",
  'imageRedaction.tech1Title': "Detection",
  'imageRedaction.tech1Desc': "Depends on sharpness, target size and occlusion; validate on your footage first.",
  'imageRedaction.tech2Title': "Processing time",
  'imageRedaction.tech2Desc': "Asynchronous tasks; time depends on image size, content and queueing.",
  'imageRedaction.tech3Title': "Styles",
  'imageRedaction.tech3Desc': "Blur, mosaic or solid fill.",
  'imageRedaction.tech4Title': "Parameters",
  'imageRedaction.tech4Desc': "Masking style and strength are configured as agreed at integration.",
  'imageRedaction.apiTitle': "API integration",
  'imageRedaction.apiSubtitle': "Interface documentation and examples are provided after the trial application.",
  'imageRedaction.apiExample': 'Example Code',
  'imageRedaction.copyCode': 'Copy Code',
  'imageRedaction.ctaTitle': "Process your images",
  'imageRedaction.ctaSubtitle': "For yourself, open Damaya; for your system, apply for an API trial.",
  'imageRedaction.ctaButton1': "Use Damaya",
  'imageRedaction.ctaButton2': "Apply for an API trial",
  
  // File Redaction Page
  'fileRedaction.heroTitle': 'File Privacy Processing',
  'fileRedaction.heroSubtitle': "Document redaction is assessed on samples for format, targets and output; it is outside the standard image and video API pricing.",
  'fileRedaction.feature1Title': "Formats",
  'fileRedaction.feature1Desc': "PDF, JSON, CSV and TXT first; Word, Excel and PowerPoint confirmed separately.",
  'fileRedaction.feature2Title': "Multi-page documents",
  'fileRedaction.feature2Desc': "Multi-page PDFs processed as one document with results per page.",
  'fileRedaction.feature3Title': "Output validation",
  'fileRedaction.feature3Desc': "Output format, layout and readability confirmed on real samples; exact layout preservation is not guaranteed by default.",
  'fileRedaction.formatsTitle': "Format list",
  'fileRedaction.formatsSubtitle': "For scoping; the actual scope follows sample validation.",
  'fileRedaction.pdf': 'PDF',
  'fileRedaction.pdfDesc': "Assessed first",
  'fileRedaction.word': 'Word',
  'fileRedaction.wordDesc': "Confirmed separately",
  'fileRedaction.excel': 'Excel',
  'fileRedaction.excelDesc': "Confirmed separately",
  'fileRedaction.ppt': 'PowerPoint',
  'fileRedaction.pptDesc': "Confirmed separately",
  'fileRedaction.txt': 'TXT',
  'fileRedaction.txtDesc': "Assessed first",
  'fileRedaction.rtf': 'RTF',
  'fileRedaction.rtfDesc': "Confirmed separately",
  'fileRedaction.scenariosTitle': "Common documents",
  'fileRedaction.scenariosSubtitle': "Four document types that come up in scoping",
  'fileRedaction.scenario1Title': "Contracts and agreements",
  'fileRedaction.scenario1Desc': "Party names, ID numbers, contact details, amounts.",
  'fileRedaction.scenario2Title': "Forms and registers",
  'fileRedaction.scenario2Desc': "Names, phone numbers and ID numbers in registration exports.",
  'fileRedaction.scenario3Title': "Public notices",
  'fileRedaction.scenario3Desc': "ID numbers and addresses in published notices, partially masked by rule.",
  'fileRedaction.scenario4Title': "Personnel files",
  'fileRedaction.scenario4Desc': "Personal information in employee records and HR documents.",
  'fileRedaction.techTitle': "How it works",
  'fileRedaction.techSubtitle': "Text layer first, OCR for scans",
  'fileRedaction.tech1Title': "OCR",
  'fileRedaction.tech1Desc': "Scans and image-only PDFs are read first, then sensitive content is located.",
  'fileRedaction.tech2Title': "Layout analysis",
  'fileRedaction.tech2Desc': "Body text, tables and images are told apart and located precisely.",
  'fileRedaction.tech3Title': "Output review",
  'fileRedaction.tech3Desc': "Results and output format are checked before integration; the parts you will review manually are agreed.",
  'fileRedaction.ctaTitle': "Confirm the document scope first",
  'fileRedaction.ctaSubtitle': "Describe formats, samples and volume; we assess and quote a deliverable scope.",
  'fileRedaction.ctaButton1': "Discuss document processing",
  'fileRedaction.ctaButton2': "View standard API scope",
  
  // Video Redaction Page
  'videoRedaction.heroTitle': 'Video Privacy Processing',
  'videoRedaction.heroSubtitle': "Faces and license plates detected and tracked frame by frame, rendered asynchronously. The standard API supports up to 1080p at 30 FPS in the first batch.",
  'videoRedaction.feature1Title': "Tracking",
  'videoRedaction.feature1Desc': "Faces and plates stay tracked while people walk and turn; occlusion, blur and small distant targets need review.",
  'videoRedaction.feature2Title': "Batches",
  'videoRedaction.feature2Desc': "Submit several videos at once; each is processed asynchronously.",
  'videoRedaction.feature3Title': "Formats",
  'videoRedaction.feature3Desc': "Support is judged by codec, frame rate and resolution, not by file extension.",
  'videoRedaction.demoTitle': "Real output: mall entrance, 20 seconds",
  'videoRedaction.demoSubtitle': "Production output; play it and unmute.",
  'videoRedaction.demoCaption': "Night-time mall entrance phone video: faces of passers-by and family stay detected and blurred while people walk, turn and pass through the glass doors; the rest of the frame and the audio are unchanged.",
  'videoRedaction.demoFact1': "20 seconds at 1080×1920; 149 objects detected automatically, 13 person tracks.",
  'videoRedaction.demoFact2': "Review each object in the editor, keep selected people or add regions, then re-render.",
  'videoRedaction.demoFact3': "Output matches the source specification; audio kept.",
  'videoRedaction.compareTitle': "Night market: many people at once",
  'videoRedaction.compareSubtitle': "All faces pixelated; signs and goods unchanged.",
  'videoRedaction.originalVideo': "Before",
  'videoRedaction.originalDesc': 'Contains clear face and license plate information',
  'videoRedaction.processedVideo': "After",
  'videoRedaction.processedDesc': 'Faces and license plates automatically redacted',
  'videoRedaction.featuresTitle': "Features",
  'videoRedaction.featuresSubtitle': "Four points about video processing",
  'videoRedaction.feat1Title': "Multiple targets",
  'videoRedaction.feat1Desc': "Several faces and plates in one frame are tracked and processed together.",
  'videoRedaction.feat2Title': "Resolution",
  'videoRedaction.feat2Desc': "Standard API first batch: 1080p / 30 FPS; 4K and high frame rates assessed separately.",
  'videoRedaction.feat3Title': "GPU rendering",
  'videoRedaction.feat3Desc': "Decoding, detection and encoding run on GPU on the server; the browser only uploads and reviews.",
  'videoRedaction.feat4Title': "Audio",
  'videoRedaction.feat4Desc': "Only the picture changes; the audio track is kept as is.",
  'videoRedaction.scenariosTitle': "Common scenarios",
  'videoRedaction.scenariosSubtitle': "Four sources of video footage",
  'videoRedaction.scenario1Title': 'Surveillance Footage',
  'videoRedaction.scenario1Desc': "Faces in playback clips, processed before export.",
  'videoRedaction.scenario2Title': "News and promotional video",
  'videoRedaction.scenario2Desc': "Passers-by and plates that are not the subject.",
  'videoRedaction.scenario3Title': "Teaching and training recordings",
  'videoRedaction.scenario3Desc': "Faces of students and observers.",
  'videoRedaction.scenario4Title': 'Meeting Recordings',
  'videoRedaction.scenario4Desc': "Faces of participants.",
  'videoRedaction.formatsTitle': 'Supported Formats',
  'videoRedaction.formatsSubtitle': "MP4 and MOV (H.264 / HEVC) validated first; other containers and codecs assessed on samples.",
  'videoRedaction.mp4': 'MP4',
  'videoRedaction.mp4Desc': "H.264 / HEVC",
  'videoRedaction.mov': 'MOV',
  'videoRedaction.movDesc': "QuickTime, H.264 / HEVC",
  'videoRedaction.other': 'Other containers',
  'videoRedaction.otherDesc': 'Assessed with samples',
  'videoRedaction.techTitle': "How it works",
  'videoRedaction.techSubtitle': "Detect, track, render",
  'videoRedaction.tech1Title': "Detect",
  'videoRedaction.tech1Desc': "Faces and plates are detected on every frame.",
  'videoRedaction.tech2Title': "Track",
  'videoRedaction.tech2Desc': "Detections of the same target are linked into tracks to reduce flicker; complex scenes still need a check of the output.",
  'videoRedaction.tech3Title': "Render",
  'videoRedaction.tech3Desc': "Masking and encoding run on GPU; output matches the source specification.",
  'videoRedaction.ctaTitle': "Process your video",
  'videoRedaction.ctaSubtitle': "For yourself, open Damaya; for your system, apply for an API trial.",
  'videoRedaction.ctaButton1': "Use Damaya",
  'videoRedaction.ctaButton2': "Apply for an API trial",

  // Privacy Policy Page
  privacyPolicy: {
    heroTitle: 'Privacy Policy',
    lastUpdated: 'Last Updated: January 6, 2026',
    introduction: {
      title: 'Introduction',
      p1: 'Zhengzhou ORedact Information Technology Co., Ltd. (hereinafter referred to as "we", "the company" or "ORedact") provides image and video privacy identification and redaction services to enterprises and institutions; text and document redaction is offered after sample assessment.',
      p2: 'We understand that the data you process may involve personal information, sensitive personal information, medical or business confidential data. Therefore, we regard privacy protection and data security as the core principles of product design and operation.',
      p3: 'This privacy policy aims to explain how we collect, use, store, protect and process your information, as well as your relevant rights under the law.',
      important: 'Important Notice:',
      importantNote: 'ORedact will not use your uploaded content for model training, data analysis, advertising purposes, or any form of secondary use, unless we obtain your explicit written authorization.',
      p4: 'By using our services, you acknowledge that you have read and agree to all the contents of this privacy policy.',
    },
    section1: {
      title: '1. Information We Collect',
      subsection1: {
        title: '1.1 Types of Information',
        p1: 'We may collect the following categories of information:',
        category1: {
          title: '(1) Account and Identity Information',
          items: ['Username', 'Email address', 'Contact information', 'Company name, organization information (if applicable)'],
        },
        category2: {
          title: '(2) Service Usage and Technical Information',
          items: ['Login and access logs', 'Feature usage and operation records', 'IP address, browser type, device information, operating system'],
        },
        category3: {
          title: '(3) Processing Data You Actively Upload',
          items: ['Text, documents, images, audio, video and other content', 'The above content may contain personal information or sensitive personal information'],
        },
        warning: 'Special Notice:',
        warningNote: 'The processing data you upload is only used to complete the privacy identification or redaction tasks you initiate. We will not actively view, analyze or retain such content.',
      },
      subsection2: {
        title: '1.2 Methods of Information Collection',
        items: [
          'Information you actively provide (account registration, data upload, request submission, etc.)',
          'Information automatically collected by the system (Cookies, log files, etc.)',
          'Information provided by legitimate third-party services (such as payment, identity verification or security services)',
        ],
      },
    },
    section2: {
      title: '2. Purpose of Information Use and Processing Principles',
      subsection1: {
        title: '2.1 Purpose of Use',
        p1: 'We only use your information within the following scope:',
        items: [
          'Provide, maintain and optimize privacy redaction services',
          'Execute data processing tasks you explicitly request',
          'Account management, technical support and service notifications',
          'Security monitoring, risk control and abuse prevention',
          'Compliance with laws, regulations and regulatory requirements',
        ],
      },
      subsection2: {
        title: '2.2 Data Processing Principles',
        p1: 'We strictly follow the following principles:',
        items: [
          'Principle of minimum necessity: Only process data necessary to achieve service purposes',
          'Principle of purpose limitation: Do not exceed the scope of explicitly stated purposes',
          'Principle of data isolation: Different customer data are isolated from each other',
          'Principle of customer control: Data is customer-led and can be deleted at any time',
          'Principle of no training: Not used for AI or algorithm model training',
        ],
      },
    },
    section3: {
      title: '3. Data Security and Protection Measures',
      subsection1: {
        title: '3.1 Technical and Management Measures',
        p1: 'We adopt security measures that meet industry standards, including but not limited to:',
        items: [
          'TLS / SSL encrypted transmission',
          'Data encryption at rest (if applicable)',
          'Strict access control and permission levels',
          'Operation audit and security logs',
          'Regular vulnerability scanning and security assessments',
          'Automated data backup and disaster recovery mechanisms',
        ],
      },
      subsection2: {
        title: '3.2 Data Storage and Hosting',
        items: [
          'Data is stored in data centers that meet international security standards such as ISO 27001',
          'Support regional deployment (such as China, Asia-Pacific, Europe and America)',
          'Regularly clean up data that is no longer needed',
        ],
      },
    },
    section4: {
      title: '4. Data Sharing and Third Parties',
      p1: 'We will not sell, rent or otherwise trade your personal information.',
      p2: 'We may share necessary information only under the following circumstances:',
      items: [
        'With your explicit authorization',
        'Necessary for service fulfillment (such as payment, cloud infrastructure)',
        'Required by laws, regulations or regulatory authorities',
        'To protect the legitimate rights and interests of users, the public or the company',
      ],
      subsection1: {
        title: '4.1 Third-Party Service Providers',
        p1: 'We may use reviewed third-party service providers to assist in providing services. They may only process data within the necessary scope and must comply with strict confidentiality and security obligations.',
      },
    },
    section5: {
      title: '5. Your Rights',
      p1: 'According to applicable laws (including the Personal Information Protection Law and GDPR), you enjoy the following rights:',
      items: [
        'Right of access',
        'Right of rectification',
        'Right of erasure',
        'Right to restrict processing',
        'Right to data portability',
        'Right to object',
        'Right to withdraw consent',
      ],
      p2: 'If you wish to exercise the above rights, please contact us through the contact methods listed in this policy.',
    },
    section6: {
      title: '6. Cookies and Similar Technologies',
      p1: 'We use Cookies and similar technologies to ensure the normal operation of the website and improve user experience.',
      subsection1: {
        title: '6.1 Types of Cookies',
        items: [
          'Essential Cookies: Ensure basic website functions',
          'Functional Cookies: Save preference settings',
          'Analytical Cookies: Used for anonymous statistical analysis',
          'Marketing Cookies: Used to provide relevant content (if applicable)',
        ],
      },
      p2: 'You can manage Cookie preferences through browser settings, but disabling some Cookies may affect website functionality.',
    },
    section7: {
      title: '7. Data Retention Period',
      table: {
        dataType: 'Data Type',
        retentionPeriod: 'Retention Period',
        accountInfo: 'Account Information',
        accountInfoPeriod: 'During account existence',
        processingData: 'Processing Data',
        processingDataPeriod: "Enterprise API: per the retention period and deletion method agreed in the service agreement; Damaya: per the Damaya privacy policy, not restated here",
        systemLogs: 'System Logs',
        systemLogsPeriod: 'Maximum 12 months',
        legalData: 'Legally Required Data',
        legalDataPeriod: 'Retained as required by law',
      },
      note: 'Retention and deletion of files uploaded to Damaya (damaya.cn) and their results are governed by the Damaya privacy policy:',
    },
    section8: {
      title: '8. Data Location and Cross-border Transfers',
      p1: 'Our services process and store data within mainland China. If a cross-border transfer is involved, we will:',
      items: [
        'Carry out the personal information export assessment or other procedures required by law',
        'Inform you of the recipient, purpose and method of processing, and obtain the necessary consent',
        'Apply appropriate technical and organizational safeguards',
      ],
    },
    section9: {
      title: '9. Policy Updates',
      p1: 'We may update this privacy policy from time to time.',
      p2: 'If there are significant changes, we will notify you through website announcements or email.',
      p3: 'Continued use of our services indicates your acceptance of the updated privacy policy.',
    },
    section10: {
      title: '10. Contact Us',
      p1: 'If you have any questions about this privacy policy or matters related to personal information protection,',
      p2: 'or wish to exercise relevant rights under applicable laws,',
      p3: 'please contact us through the following methods:',
      email: 'Contact: contact@oredact.com',
      p4: 'We will reply within 30 days after receiving your request.',
    },
  },

  // Terms of Service Page
  termsOfService: {
    heroTitle: 'Terms of Service',
    lastUpdated: 'Last Updated: January 6, 2026',
    introduction: {
      title: 'Introduction',
      p1: 'Welcome to ORedact Privacy Protection Service!',
      p2: 'This Terms of Service (hereinafter referred to as "this Agreement") is entered into between you (individual or organization, hereinafter referred to as "User") and',
      p3: 'Zhengzhou ORedact Information Technology Co., Ltd. (hereinafter referred to as "we", "the company" or "ORedact") regarding your use of the privacy information identification and redaction technical services provided by ORedact.',
      p4: 'Please carefully read and fully understand all terms of this Agreement before using the service.',
      p5: 'Once you start using our services, you are deemed to have agreed to be bound by this Agreement.',
      p6: 'If you do not agree to any content of this Agreement, please do not use this service.',
    },
    section1: {
      title: '1. Definitions',
      service: {
        term: '"Service"',
        desc: 'refers to the privacy identification and redaction technical services provided by ORedact: image and video redaction, text and document redaction offered after assessment, and the related APIs, platform and technical support.',
      },
      user: {
        term: '"User"',
        desc: 'refers to individuals, enterprises or other organizations that register, access or use this service.',
      },
      content: {
        term: '"Content"',
        desc: 'refers to any data, files or information uploaded, submitted, called or processed through this service by users.',
      },
      account: {
        term: '"Account"',
        desc: 'refers to the account registered by users on the ORedact platform and used to access the service.',
      },
      ip: {
        term: '"Intellectual Property"',
        desc: 'refers to patents, trademarks, copyrights, trade secrets and other rights protected by law.',
      },
    },
    section2: {
      title: '2. Service Description',
      subsection1: {
        title: '2.1 Service Content',
        p1: 'ORedact provides privacy protection services based on artificial intelligence and automation technology, including but not limited to:',
        items: [
          'Text privacy information identification and redaction',
          'Document (such as PDF, Word, etc.) privacy information detection and processing',
          'Privacy area identification and masking in images',
          'Dynamic identification, tracking and masking of privacy content in videos',
          'Related API interfaces, SDK and technical support services',
        ],
        important: 'Important Notice:',
        importantNote: 'ORedact provides technical processing tools and capabilities, and does not constitute legal, compliance or regulatory conclusions.',
      },
      subsection2: {
        title: '2.2 Service Availability',
        p1: 'We will make reasonable efforts to ensure the continuity and stability of the service, but do not guarantee that the service will not be interrupted, delayed or error-free.',
        p2: 'The service may be temporarily interrupted due to maintenance, upgrades, system adjustments or force majeure, and we will try our best to notify in advance.',
      },
    },
    section3: {
      title: '3. User Account',
      subsection1: {
        title: '3.1 Account Registration',
        items: [
          'You should provide true, accurate and complete registration information',
          'You are responsible for keeping account information up to date',
          'You should properly keep account credentials and be responsible for all activities under the account',
        ],
      },
      subsection2: {
        title: '3.2 Account Use',
        items: [
          'Each account is for use by one user or organization only',
          'Accounts may not be transferred, rented or shared',
          'If you find that your account has been stolen or there is a security risk, you should notify us immediately',
          'We have the right to restrict, suspend or terminate accounts that violate the rules',
        ],
      },
    },
    section4: {
      title: '4. Usage Rules and Restrictions',
      subsection1: {
        title: '4. Permitted Use',
        p1: 'You may only use the service within the following scope:',
        items: [
          'For legitimate and proper privacy protection or data compliance purposes',
          'Comply with applicable laws, regulations and this Agreement',
          'Do not infringe upon the legitimate rights and interests of any third party',
        ],
      },
      subsection2: {
        title: '4.2 Prohibited Use',
        p1: 'You shall not use the service for the following situations, including but not limited to:',
        items: [
          'Any illegal, fraudulent, infringing or harmful activities',
          'Infringing upon others\' privacy rights, intellectual property rights or other legitimate rights and interests',
          'Spreading malicious code, viruses or implementing network attacks',
          'Circumventing, destroying or testing the security mechanisms of the service',
          'Reverse engineering, decompiling or illegally scraping the service',
          'High-frequency, large-scale or abnormal requests beyond reasonable use',
        ],
      },
      subsection3: {
        title: '4.3 Usage Restrictions',
        p1: 'The service may be subject to the following restrictions:',
        items: [
          'API call frequency',
          'Single file size and quantity',
          'Storage space or task concurrency quantity',
        ],
        p2: 'Specific restrictions are subject to the platform page or agreement between the parties.',
      },
    },
    section5: {
      title: '5. Intellectual Property',
      subsection1: {
        title: '5.1 ORedact\'s Intellectual Property',
        p1: 'The service itself and its related software, systems, algorithms, interfaces, trademarks and other intellectual property rights are owned by ORedact.',
        p2: 'This Agreement does not transfer any intellectual property rights to users, but only grants a limited, non-exclusive, non-transferable license to use.',
      },
      subsection2: {
        title: '5.2 User Content',
        items: [
          'Users retain ownership of their uploaded content',
          'Users grant ORedact the necessary technical processing license to provide services',
          'Users confirm that they have legal rights or authorization to the uploaded content',
        ],
        important: 'ORedact will not use user content for model training, data analysis, advertising or any purpose unrelated to the service.',
      },
      subsection3: {
        title: '5.3 Infringement Handling',
        p1: 'If you believe that the service content infringes your legitimate rights and interests, please notify us through the contact method listed in this Agreement, and we will handle it according to law.',
      },
    },
    section6: {
      title: '6. Fees and Payment',
      subsection1: {
        title: '6.1 Service Fees',
        items: [
          'Some services may require payment',
          'Specific prices are subject to the official website display or agreement between the parties',
          'We have the right to adjust prices according to law and notify in advance',
        ],
      },
      subsection2: {
        title: '6.2 Payment Terms',
        items: [
          'Users should complete payment in the agreed manner and within the agreed period',
          'Overdue payment may result in service suspension or termination',
          'Refund policy is subject to specific products or contract agreements',
        ],
      },
      subsection3: {
        title: '6.3 Taxes',
        p1: 'Unless otherwise stated, all fees do not include applicable taxes, and related taxes shall be borne by users.',
      },
    },
    section7: {
      title: '7. Disclaimer',
      subsection1: {
        title: '7.1 Service Disclaimer',
        p1: 'The service is provided "as is", and we do not make any guarantees regarding the following matters:',
        items: [
          'The service is completely error-free or uninterrupted',
          'The absolute accuracy or completeness of processing results',
          'The service is suitable for users\' specific business or compliance needs',
        ],
      },
      subsection2: {
        title: '7.2 Content Disclaimer',
        p1: 'We do not assume any responsibility for user-uploaded content, including but not limited to:',
        items: [
          'The legality, authenticity or completeness of the content',
          'Third-party rights involved in the content',
          'Any loss or consequences arising from the content',
        ],
      },
    },
    section8: {
      title: '8. Limitation of Liability',
      p1: 'To the maximum extent permitted by law:',
      items: [
        'Our cumulative liability does not exceed the service fees paid to us by users in the past 12 months',
        'We do not assume liability for indirect, incidental, special or consequential losses',
        'We do not assume liability for profit losses, data loss or business interruption',
      ],
      p2: 'Some jurisdictions may not allow the above limitations, in which case applicable law shall prevail.',
    },
    section9: {
      title: '9. User Responsibility and Indemnification',
      subsection1: {
        title: '9.1 User Responsibility',
        p1: 'Users should:',
        items: [
          'Ensure that uploaded content is legal and they have the right to process it',
          'Comply with laws, regulations and this Agreement',
          'Ensure account and data security',
        ],
      },
      subsection2: {
        title: '9.2 Security Obligations',
        p1: 'Users shall not:',
        items: [
          'Access systems or data without authorization',
          'Interfere with or disrupt service operations',
          'Spread malicious programs or attack systems',
        ],
      },
      subsection3: {
        title: '9.3 Indemnification',
        p1: 'For any claims, losses or expenses caused by users\' violation of this Agreement or illegal use of the service, users shall indemnify and hold ORedact harmless.',
      },
    },
    section10: {
      title: '10. Agreement Termination',
      subsection1: {
        title: '10.1 Termination Circumstances',
        p1: 'Under the following circumstances, we have the right to suspend or terminate the service:',
        items: [
          'User violates this Agreement',
          'Engaging in illegal or high-risk activities',
          'Long-term non-use of account',
          'Failure to pay fees as agreed',
        ],
      },
      subsection2: {
        title: '10.2 Consequences of Termination',
        items: [
          'Users will lose access to the service',
          'We may delete accounts and related data according to law',
          'Paid fees will not be refunded in principle',
        ],
      },
    },
    section11: {
      title: '11. Other Terms',
      subsection1: {
        title: '11.1 Agreement Modification',
        p1: 'We may update this Agreement from time to time. Major changes will be notified through website announcements or emails.',
        p2: 'Continued use of the service is deemed acceptance of the modified agreement.',
      },
      subsection2: {
        title: '11.2 Applicable Law and Dispute Resolution',
        p1: 'This Agreement is governed by the laws of the People\'s Republic of China.',
        p2: 'Disputes arising from this Agreement shall be submitted to the Beijing Arbitration Commission for arbitration.',
      },
      subsection3: {
        title: '11.3 Severability',
        p1: 'If any part of this Agreement is invalid, the remaining terms remain valid.',
      },
      subsection4: {
        title: '11.4 Complete Agreement',
        p1: 'This Agreement constitutes the complete agreement between the parties regarding the use of the service.',
      },
    },
    section12: {
      title: '12. Contact Us',
      p1: 'If you have any questions about this Agreement, please contact us through the following methods:',
      email: 'Contact: contact@oredact.com',
      p2: 'Thank you for choosing ORedact.',
      p3: 'We are committed to providing you with secure, reliable, and auditable privacy protection technical services.',
    },
  },
  damayaPage: {
    heroTitle: "Damaya",
    heroSubtitle: "An online AI redaction tool for images and video: upload, let it find faces, plates and sensitive text, and export the masked result from any browser.",
    heroNote: "Damaya runs at damaya.cn and is built and operated by Zhengzhou ORedact Information Technology.",
    open: "Open Damaya",
    help: "Help center",
    featuresTitle: "What Damaya does",
    f1Title: "Automatic detection", f1Desc: "Faces, license plates and text are found automatically after upload; no manual boxes.",
    f2Title: "Continuous video masking", f2Desc: "Each person or plate is tracked across frames, so masks follow walking, turning and passing cars.",
    f3Title: "Keep selected people", f3Desc: "Results are grouped by person; keep yourself or anyone who consented while everyone else stays masked, and add masks by hand where needed.",
    f4Title: "Five styles", f4Desc: "Mosaic, blur, solid fill, eye bar or sticker, previewed in the browser before export.",
    stylesTitle: "Four results from one image",
    stylesDesc: "The source image is AI-generated and shows no real person; all four results are real output from the Damaya pipeline, with faces and the plate handled together.",
    styleBefore: "Original (AI-generated)", styleBlur: "Blur", styleMosaic: "Mosaic", styleSolid: "Solid fill", styleEyebar: "Eye bar",
    stepsTitle: "Three steps",
    s1Title: "Upload", s1Desc: "JPG, PNG, WebP, MP4 and MOV; try it without an account.",
    s2Title: "Review", s2Desc: "Check the automatic result in the editor: who to keep, where to add, which style.",
    s3Title: "Download", s3Desc: "Watermarked downloads are free; unwatermarked ones use your account allowance or plan. Come back within 24 hours to adjust.",
    faqTitle: "FAQ",
    q1: "Do I need to install anything?", q1A: "No. Open damaya.cn in a browser on your phone or computer.",
    q2: "Is Damaya free?", q2A: "Detection and masking have a daily free allowance and watermarked results download free; unwatermarked results depend on your account allowance or plan. The Damaya site has the current rules.",
    q3: "Are uploads safe?", q3A: "Source files and results are deleted automatically within 24 hours and are never used for training; the service runs in mainland China. See the privacy policy.",
    q4: "How does Damaya relate to the ORedact API?", q4A: "They share one detection and redaction engine. Damaya is the self-service product; the ORedact API is for teams integrating redaction into their own systems.",
    companyTitle: "Built and operated by ORedact",
    companyDesc: "Zhengzhou ORedact Information Technology does one thing: privacy redaction for images and video, with an in-house pipeline and models, Damaya for self-service and the ORedact API for integration.",
    apiLink: "Enterprise API",
    aboutLink: "About ORedact",
  },
};
